import React from "react";
import {
  FaStore,
  FaTruck,
  FaBuilding,
  FaHeadset,
  FaClipboardCheck,
} from "react-icons/fa";

const AboutUs = () => {
  return (
    <>
      <section className="aboutSection">
        <p className="aboutLabel">WHO WE ARE</p>

        <h2>
          New Zealand’s premier event <br />
          merchandise partner
        </h2>

        <p className="aboutIntro">
          Event Merchandise Services (EMS) delivers end-to-end retail, logistics
          and infrastructure solutions at venues, arenas, entertainment centres
          and outdoor events nationwide.
        </p>

        <div className="aboutCards">
          <div className="aboutCard">
            <FaStore className="aboutIcon" />
            <h3>Merchandise Retail</h3>
            <span></span>
            <p>Complete merchandise retail services tailored to your event.</p>
          </div>

          <div className="aboutCard">
            <FaTruck className="aboutIcon" />
            <h3>Logistics & Operations</h3>
            <span></span>
            <p>Specialised entertainment logistics and on-site operations.</p>
          </div>

          <div className="aboutCard">
            <FaBuilding className="aboutIcon" />
            <h3>Venues & Events</h3>
            <span></span>
            <p>Experienced in venues, arenas, entertainment centres and outdoor events.</p>
          </div>

          <div className="aboutCard">
            <FaHeadset className="aboutIcon" />
            <h3>Support Services</h3>
            <span></span>
            <p>Reliable support services to keep your event running smoothly.</p>
          </div>

          <div className="aboutCard">
            <FaClipboardCheck className="aboutIcon" />
            <h3>One-Stop Solution</h3>
            <span></span>
            <p>Your single partner for retail, staff, infrastructure and more.</p>
          </div>
        </div>

        <div className="nzCallout">
          <img src="/img/nz.svg" className="nzMapDecor" alt="" />

          <div className="nzIcon">
            <img src="/img/nz.svg" alt="New Zealand map" />
          </div>

          <div className="nzText">
            <h3>Proudly supporting events across New Zealand</h3>
            <p>
              From concept to completion, EMS is your go-to partner for all your
              event retail, logistics and infrastructure requirements.
            </p>
          </div>
        </div>
      </section>

      <style>{`
        .aboutSection {
          width: 100%;
          padding: 90px 24px;
          background: #ffffff;
          text-align: center;
          font-family: Arial, sans-serif;
        }

        .aboutLabel {
          color: #006eff;
          font-size: 15px;
          font-weight: 900;
          letter-spacing: 5px;
          margin-bottom: 18px;
        }

        .aboutSection h2 {
          color: #07194a;
          font-size: 58px;
          line-height: 1.08;
          font-weight: 900;
          margin: 0;
        }

        .aboutIntro {
          max-width: 850px;
          margin: 28px auto 55px;
          color: #56627a;
          font-size: 22px;
          line-height: 1.5;
        }

        .aboutCards {
          max-width: 1450px;
          margin: 0 auto;
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 24px;
        }

        .aboutCard {
          min-height: 330px;
          padding: 44px 26px 36px;
          border: 1px solid #dfe5ef;
          border-radius: 18px;
          background: #ffffff;
          box-shadow: 0 12px 30px rgba(7, 25, 74, 0.06);
          transition: all 0.3s ease;
        }

        .aboutCard:hover {
          transform: translateY(-8px);
          border-color: #007cff;
          box-shadow: 0 20px 40px rgba(7, 25, 74, 0.12);
        }

        .aboutIcon {
          width: 88px;
          height: 88px;
          padding: 24px;
          border-radius: 50%;
          background: #eef5ff;
          color: #006eff;
          margin-bottom: 28px;
        }

        .aboutCard h3 {
          color: #07194a;
          font-size: 24px;
          line-height: 1.25;
          font-weight: 900;
          margin: 0;
        }

        .aboutCard span {
          display: block;
          width: 42px;
          height: 4px;
          background: #007cff;
          border-radius: 50px;
          margin: 22px auto;
        }

        .aboutCard p {
          color: #56627a;
          font-size: 17px;
          line-height: 1.45;
          margin: 0;
        }

        .nzCallout {
          position: relative;
          overflow: hidden;
          max-width: 1450px;
          margin: 34px auto 0;
          padding: 38px 55px;
          border-radius: 18px;
          background: linear-gradient(135deg,#061f3d 0%,#082a4d 60%,#005e91 100%);
          color: #ffffff;
          display: flex;
          align-items: center;
          gap: 42px;
          text-align: left;
          box-shadow: 0 18px 40px rgba(7, 25, 74, 0.18);
        }

        .nzIcon {
          width: 120px;
          height: 120px;
          border: 3px solid #007cff;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          z-index: 2;
        }

        .nzIcon img {
          width: 70px;
          height: auto;
          filter: brightness(0) invert(1);
        }

        .nzMapDecor {
          position: absolute;
          right: 45px;
          bottom: -35px;
          width: 220px;
          opacity: 0.12;
          filter: brightness(0) invert(1);
          z-index: 1;
        }

        .nzText {
          position: relative;
          z-index: 2;
        }

        .nzText h3 {
          font-size: 32px;
          line-height: 1.2;
          font-weight: 900;
          margin: 0 0 14px;
        }

        .nzText p {
          max-width: 820px;
          font-size: 20px;
          line-height: 1.5;
          margin: 0;
          color: rgba(255,255,255,0.9);
        }

        @media (max-width: 1200px) {
          .aboutCards {
            grid-template-columns: repeat(3, 1fr);
          }
        }

        @media (max-width: 800px) {
          .aboutSection h2 {
            font-size: 40px;
          }

          .aboutIntro {
            font-size: 18px;
          }

          .aboutCards {
            grid-template-columns: 1fr;
          }

          .nzCallout {
            flex-direction: column;
            text-align: center;
            padding: 38px 28px;
          }

          .nzMapDecor {
            right: 50%;
            transform: translateX(50%);
            bottom: -55px;
            width: 180px;
            opacity: 0.08;
          }

          .nzText h3 {
            font-size: 26px;
          }

          .nzText p {
            font-size: 17px;
          }
        }
      `}</style>
    </>
  );
};

export default AboutUs;